export default {
    monitor: {name: "Monitor"},
    keyboard: {name: "Teclado"},
    mouse: {name: "Ratón"},
    webcam: {name: "Cámara web"},
    headset: {name: "Auriculares"},
    dockingStation: {name: "Estación de acoplamiento"},
}